import * as React from 'react';
import { connect } from 'react-redux';
import {
  SettingTabPanelList,
  SettingTabPanelListRow,
} from '../../common/SettingTabPanelList';
import ToolIconRadioButtonSet from '../../common/ToolIconRadioButtonSet';
import { Dispatch, Action } from 'redux';
import ShapeKindTabPanelListRow from './ShapeKindTabPanelListRow';
import { AppStates } from '../../../reducers/app';
import ObjectDrawingUIAction from '../../../actions/ui/ObjectDrawingUIAction';
import StampButton from './StampButton';
import { getBasePath } from '../../../utils/browser';
import { Publication } from '../../../types/epub';
import { defaultStamps } from '../../../drawing/constants';
import { StampType } from '../../../drawing/types';

const stampPanelContainerStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: '#fff',
  width: '334px',
  border: '1px #aaa solid',
  marginLeft: '100px',
  marginRight: '65px',
  paddingLeft: '2px',
  paddingRight: '2px',
};

const titleImageStyle: React.CSSProperties = {
  width: '118px',
  height: '36px',
  marginTop: '4px',
};

interface StampSettingTabPanelProps {
  readonly selected: number;
  readonly selectedStampIndex: number;
  readonly stampType: StampType;
  readonly publication: Publication | undefined;
  readonly dispatch: Dispatch<Action>;
}

const StampSettingTabPanel: React.SFC<
  StampSettingTabPanelProps
> = React.memo((props) => {
  const { selected, selectedStampIndex, stampType, publication, dispatch } = props;
  const defaultStampButtons: JSX.Element[] = [];
  const extraStampButtons: JSX.Element[] = [];
  const baseDir = getBasePath();
  const stampTitleSrc = `${baseDir}/images/setting-popup/text/text_shape_stamp.png`;

  const extraStampPaths = publication ? publication.extraStamps.map(stamp => stamp.path) : [];
  const publicationDir = publication ? publication.resourceDir : '';

  for (let i = 0; i < defaultStamps.length; i += 1) {
    const num = `${i + 1}`;
    const src =  `${baseDir}/${defaultStamps[i].path}`;
    defaultStampButtons.push(
      <StampButton
        key={num}
        imagesSrc={src}
        active={selectedStampIndex === i && stampType === StampType.Default }
        onClick={() => {
          ObjectDrawingUIAction.selectStampType(selected, i, StampType.Default, dispatch);
        }} />,
    );
  }

  for (let i = 0; i < extraStampPaths.length; i += 1) {
    const num = `${i + 1}`;
    const src =  `${publicationDir}/${extraStampPaths[i]}`;

    extraStampButtons.push(
      <StampButton
        key={num}
        imagesSrc={src}
        active={selectedStampIndex === i && stampType === StampType.Extra }
        onClick={() => {
          ObjectDrawingUIAction.selectStampType(selected, i, StampType.Extra, dispatch);
        }} />,
    );
  }

  return (
    <SettingTabPanelList>
      <ShapeKindTabPanelListRow />
      <SettingTabPanelListRow>
        <div style={stampPanelContainerStyle}>
          <img src={stampTitleSrc} style={titleImageStyle} />
          <ToolIconRadioButtonSet>
            {defaultStampButtons}
          </ToolIconRadioButtonSet>
          <hr style={{ width: '100%' }} />
          <ToolIconRadioButtonSet>
            {extraStampButtons}
          </ToolIconRadioButtonSet>
        </div>
      </SettingTabPanelListRow>
    </SettingTabPanelList>
  );
});

const mapStateToProps = (appStates: AppStates) => {
  const { selected, toolSettings } = appStates.ui.objectDrawing;
  return {
    selected,
    selectedStampIndex: toolSettings[selected].selectedStampIndex,
    stampType: toolSettings[selected].stampType,
    publication: appStates.publication,
  };
};

export default connect(mapStateToProps)(StampSettingTabPanel);
